export default {"src":"/_next/static/media/icon_more_news.f8011b9c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};